import CustomNumberInput from './custom-number-input.vue'
export type { CustomNumberInputProps } from './props'
export default CustomNumberInput